import { MutationTree } from 'vuex'
import { MyUploadedDocumentState } from './state'
import { MyUploadedDocument } from '@/app/my-uploaded-documents/entities/my-uploaded-document.entity'

export const mutations: MutationTree<MyUploadedDocumentState> = {
    updateDocuments(state: MyUploadedDocumentState, documents: MyUploadedDocument[]) {
        state.documents = documents
        state.hasLoaded = true
        state.error = undefined
    },
    setHasLoaded(state: MyUploadedDocumentState, loaded: boolean) {
        state.hasLoaded = loaded
    },
    setError(state: MyUploadedDocumentState, error: string | undefined) {
        state.error = error
    }
}


